// extracted by mini-css-extract-plugin
module.exports = {"container":"_9330de7794--container--FGPNc","text":"_9330de7794--text--iI6Ce"};